
import { payforOne } from '@/api/task/withdraw'
import { approvalRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
@Component({
  name: 'approval',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any

  private statusList: any[] = []
  private setForm: any = {
    product: null,
    product_account: null,
    google_code: ''
  }
  private rules = approvalRules
  private loading: boolean = false
  private productList: any[] = []
  private accountList: any[] = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back () {
    this.setForm = {
      product: null,
      product_account: null,
      google_code: ''
    }
    this.$emit('close')
  }

  private async payforOne () {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          ordernumber: this.info.ordernumber,
          ...this.setForm
        }
        try {
          await payforOne(data).then(() => {
            this.$message({
              message: 'Approval successfully!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  // 获取产品列表
  private async getProductList () {
    await getProductList({
      product_type: this.info.product_type,
      currency: this.info.currency
    }).then((res: any) => {
      this.productList = res
    })
  }

  private selProduct () {
    this.setForm.product_account = null
    this.getAccountList()
  }

  // 获取产品账户列表
  private async getAccountList () {
    const params = {
      product: this.setForm.product,
      status: 1,
      page: 1,
      page_size: 1000
    }
    await getProductAccountList(params).then((res: any) => {
      this.accountList = res.results
    })
  }

  created () {
    this.getProductList()
  }
}
